module.exports = __webpack_public_path__ + "a5581c024.png";